<span class="qa-quick-filter-label">
  <ng-container [ngSwitch]="quickFilterType">
    <ng-container
      *ngSwitchCase="'hasLibraryNote'"
      i18n="@@quickFilter-label-hasLibraryNote"
    >
      Has library note
    </ng-container>
    <ng-container *ngSwitchCase="'readingIntention'">
      <ng-container [ngSwitch]="quickFilterId">
        <ng-container
          *ngSwitchCase="ReadingIntentionsKey.Undecided"
          i18n="@@quickFilter-label-undecided"
          >Undecided</ng-container
        >
        <ng-container
          *ngSwitchCase="ReadingIntentionsKey.PlanToConsume"
          i18n="@@quickFilter-label-willRead"
          >Will read</ng-container
        >
        <ng-container
          *ngSwitchCase="ReadingIntentionsKey.CurrentlyConsuming"
          i18n="@@quickFilter-label-readingNow"
          >Reading now</ng-container
        >
        <ng-container
          *ngSwitchCase="ReadingIntentionsKey.HaveConsumed"
          i18n="@@quickFilter-label-haveRead"
          >Have read</ng-container
        >
        <ng-container
          *ngSwitchCase="ReadingIntentionsKey.DecidedNotToConsume"
          i18n="@@quickFilter-label-wontRead"
          >Won't read</ng-container
        >
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'studyNotes'">
      <ng-container [ngSwitch]="quickFilterId">
        <ng-container *ngSwitchCase="true" i18n="@@quickFilter-label-notes"
          >Personal Notes</ng-container
        >
        <ng-container
          *ngSwitchCase="false"
          i18n="@@quickFilter-label-withoutNotes"
          >Without Personal Notes</ng-container
        >
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'resourceType'">
      <ng-container [ngSwitch]="quickFilterId">
        <ng-container
          *ngSwitchCase="false"
          i18n="@@quickFilter-label-physicalResource"
          >Physical Resource</ng-container
        >
        <ng-container
          *ngSwitchCase="true"
          i18n="@@quickFilter-label-onlineResource"
          >Online Resource</ng-container
        >
      </ng-container>
    </ng-container>
    <ng-container
      *ngSwitchCase="'digitisationStatus'"
      [ngSwitch]="quickFilterId"
    >
      <ng-container
        *ngSwitchCase="DigitisationFilterStatus.DIGITISED"
        i18n="@@quickFilter-label-digitised"
      >
        Digitised
      </ng-container>
      <ng-container
        *ngSwitchCase="DigitisationFilterStatus.DIGITISATION_PENDING"
        i18n="@@quickFilter-label-digitisationPending"
      >
        Digitisation Pending
      </ng-container>
      <ng-container
        *ngSwitchCase="DigitisationFilterStatus.NO_DIGITISATION"
        i18n="@@quickFilter-label-noDigitisation"
      >
        No Digitisation
      </ng-container>
    </ng-container>
    <ng-container
      *ngSwitchCase="'courseReserveStatus'"
      [ngSwitch]="quickFilterId"
    >
      <ng-container
        *ngSwitchCase="CourseReserveFilterStatus.COURSE_RESERVE"
        i18n="@@quickFilter-label-courseReserve"
      >
        Course reserve
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>{{ quickFilterValue }}</ng-container>
  </ng-container>
</span>
